import React from "react";
import { Box } from "@mui/material";

export default function ResponsiveTableWrapper({ children, minWidth = 720, sx = {} }) {
  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: "100%",
        minWidth: 0,
        overflowX: "auto",
        overflowY: "hidden",
        WebkitOverflowScrolling: "touch",
        borderRadius: 1,
        "& table": {
          minWidth,
          width: "100%"
        },
        "& th, & td": {
          whiteSpace: "normal",
          overflowWrap: "anywhere",
          wordBreak: "break-word",
          verticalAlign: "top"
        },
        "& .MuiButton-root": {
          whiteSpace: "normal"
        },
        ...sx
      }}
    >
      {children}
    </Box>
  );
}
